import jwtDecode from 'jwt-decode';
export function decodeJwt(jwt) {
    return jwtDecode(jwt);
}
//# sourceMappingURL=JwtHelpers.js.map